import { useMemo } from 'react';
import { useColorConfig } from './colorConfig';

export const useStatusColor = () => {
  const colors = useColorConfig();

  const getStatusColor = useMemo(() => (status) => {
    switch (status) {
      case 'right':
        return colors.success;
      case 'wrong':
        return colors.error;
      case 'unanswered':
        return colors.textSecondary;
      default:
        return colors.textSecondary;
    }
  }, [colors]);

  return getStatusColor;
};
